import { createSlice } from "@reduxjs/toolkit";
import HbsUcretTarifetanimDTO from "src/models/Settings/Generals/HbsUcretTarifeTanimDTO";
import UcretTarifeSablonExcel from "src/models/Settings/Generals/UcretTarifeSablonExcel";
import VwUcrettarifeDTO from "src/models/Settings/Generals/VwUcrettarifeDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

export class UcretTarifeTanimAramaKriterleri {
    aciklama?: string = "";
}
export class IslemListesiEkleLastValues {
    aktifBool?: boolean = true;
    paketDahilBool?: boolean = false;
    islempuan?: number = null;
    parabirimId?: number = null;
    kdvdahil?: string = "H";
    hesaplamaformulId?: number = null;
}
interface IUcretTarifeTanim {
    ucretTarifeTanimEkle?: boolean;
    ucretTarifeTanimActiveRow?: HbsUcretTarifetanimDTO;
    ucretTarifeTanimId?: number;
    aramaKriterleri?: UcretTarifeTanimAramaKriterleri;
    islemEkle?: boolean;
    tarifeActiveRow?: VwUcrettarifeDTO;
    ayniKaydiGetirmeId?: Array<number>;
    tarifedenKopyala?: boolean;
    excelSablon?: Array<UcretTarifeSablonExcel>
    kurumId:number;    
    islemListesiYenilensinmi:boolean,
    islemListesiEkleLastValues?:IslemListesiEkleLastValues

};

export const UcretTarifeTanimSlice = createSlice<IUcretTarifeTanim, MapReducerPayloads<IUcretTarifeTanim, {
    setUcretTarifeTanimEkle?: boolean;
    setUcretTarifeTanimActiveRow?: HbsUcretTarifetanimDTO;
    setUcretTarifeTanimId?: number;
    setAramaKriterleri?: UcretTarifeTanimAramaKriterleri;
    setIslemEkle?: boolean;
    setTarifeActiveRow?: VwUcrettarifeDTO;
    setAyniKaydiGetirmeId?: Array<number>;
    setTarifedenKopyala?: boolean;
    setExcelSablon?: Array<UcretTarifeSablonExcel>;
    setKurumId:number
    setIslemListesiYenilensinmi:boolean,
    setIslemListesiEkleLastValues:IslemListesiEkleLastValues
}>>({
    name: "UcretTarifeTanimState",
    initialState: {
        ucretTarifeTanimEkle: false,
        ucretTarifeTanimActiveRow: new HbsUcretTarifetanimDTO(),
        ucretTarifeTanimId: 0,
        aramaKriterleri: new UcretTarifeTanimAramaKriterleri(),
        islemEkle: false,
        tarifeActiveRow: new VwUcrettarifeDTO(),
        ayniKaydiGetirmeId: [],
        tarifedenKopyala: false,
        excelSablon: new Array<UcretTarifeSablonExcel>(),
        kurumId:0,
        islemListesiYenilensinmi:false,
        islemListesiEkleLastValues:new IslemListesiEkleLastValues(),
    },
    reducers: {
        setUcretTarifeTanimEkle: (state, action) => {
            state.ucretTarifeTanimEkle = action.payload
        },
        setUcretTarifeTanimActiveRow: (state, action) => {
            state.ucretTarifeTanimActiveRow = action.payload
        },
        setUcretTarifeTanimId: (state, action) => {
            state.ucretTarifeTanimId = action.payload
        },
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        setIslemEkle: (state, action) => {
            state.islemEkle = action.payload
        },
        setTarifeActiveRow: (state, action) => {
            state.tarifeActiveRow = action.payload
        },
        setAyniKaydiGetirmeId: (state, action) => {
            state.ayniKaydiGetirmeId = action.payload
        },
        setTarifedenKopyala: (state, action) => {
            state.tarifedenKopyala = action.payload
        },
        setExcelSablon: (state, action) => {
            state.excelSablon = action.payload
        },
        setKurumId: (state, action) => {
            state.kurumId = action.payload
        },
        setIslemListesiYenilensinmi: (state, action) => {
            state.islemListesiYenilensinmi = action.payload
        },
        setIslemListesiEkleLastValues: (state, action) => {
            state.islemListesiEkleLastValues = action.payload
        }
    }
});